module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAj0lEQVR42u3aMQqAMAxA0ZxGvIEH8v6be1wcMihIdRDzAn9ueUspbWRmdC4AAAAAAAAAAAAAAGgOsM1LjlQnpvW0OqPrvB0AAAAAAAAAAAAAAAAAADh6PHcAPjQAAFSAq83/NQAAAAAA4BgEAMBlCAAAAAAAAAAAAAAAAAC6vwz5KQoAAAAAAAAAAAAAQJ92kvoFFv/ks+MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Norway.png
// module id = i9Ik
// module chunks = 0 62 63